import { isLifecycleLoginError, reactivateFromCredentials } from "../../js/api/accountLifecycle";
import { payUrl } from "../../js/utils/siteLinks";

export default function LifecycleLoginNote({ error, form, onReactivated }) {
  if (!error || !isLifecycleLoginError(error)) return null;

  const canReturn = error.code === "suspended";
  const canRequest = error.code === "cancelled" && error.graceOpen;

  async function resume() {
    try {
      await reactivateFromCredentials(form);
      if (onReactivated) onReactivated();
    } catch (next) {
      window.alert(next.message);
    }
  }

  const payHref = form?.email
    ? payUrl({ role: error.code === "broker" ? "broker" : "agent", email: form.email })
    : payUrl({ role: "agent" });

  return (
    <div className="lifecycle-login-note">
      {canReturn ? (
        <button type="button" className="ghost-btn" onClick={resume}>
          Return from leave
        </button>
      ) : null}
      {canRequest ? (
        <button type="button" className="ghost-btn" onClick={resume}>
          Request reactivation
        </button>
      ) : null}
      {canReturn || canRequest ? (
        <a className="ghost-btn" href={payHref} target="_blank" rel="noreferrer">
          Restore via payment
        </a>
      ) : null}
    </div>
  );
}
